<div class="dropdown-container">
  <mat-select
    multiple
    [formControl]="control"
    placeholder="Select document type"
  >
    @for (docType of documentTypes; track docType.id) {
      <mat-option [value]="docType.id">{{ docType.label }}</mat-option>
    }
  </mat-select>
  @if (control.value) {
    <div (click)="clearSelection($event)">
      <mat-icon>close</mat-icon>
    </div>
  }
</div>
